import { NegotiationCaseVariant } from '@procureai/constellation/clara/negotiation-case';

export const columnKey = (i: number) => `column${i}`;
export const createColumnFields = <D>(valueGetter: (item: D) => any, data: D[]) => ({
  ...data.reduce(
    (acc, item, i) => {
      acc[columnKey(i)] = valueGetter(item);
      return acc;
    },
    {} as Record<string, NegotiationCaseVariant>,
  ),
});
